export const categories = {
  // Modal titles
  'categories.newCategory': 'Nouvelle catégorie',
  'categories.editCategory': 'Modifier la catégorie',
  'categories.assignToCategories': 'Assigner les clients aux catégories',
  'categories.selectCategoryForClient': 'Sélectionnez une catégorie pour chaque client',
  
  // Actions
  'categories.noCategory': 'Aucune catégorie',
  
  // Messages
  'categories.saveSuccess': 'Catégorie enregistrée avec succès',
  'categories.deleteSuccess': 'Catégorie "{name}" supprimée',
  'categories.saveFailed': 'Échec de la sauvegarde de la catégorie',
  'categories.cannotDeleteDefault': 'Les catégories par défaut ne peuvent pas être supprimées',
  'categories.deleteFailed': 'Échec de la suppression',
  'categories.confirmDelete': 'Supprimer la catégorie "{name}" ?',
} as const;
